export const getChartModeTypes = (viewMode, percentsOnly = false) => {
  if (viewMode === 'scatter') {
    return []
  }

  if (viewMode === 'stacked' || percentsOnly) {
    return ['percents', 'bpercents']
  }

  return ['respondents', 'percents', 'brespondents', 'bpercents']
}
